import { PixelRatio } from 'react-native';

export const isRetina = PixelRatio.get() >= 2;